





































































import { Component, Vue, Prop } from "vue-property-decorator";
import PartnerReportDetailImageTimeLineElement from "@/components/partner/PartnerReportDetailImageTimeLineElement.vue";
import DamageLocatorCombined from "@/components/damagelocator/DamageLocatorCombined.vue";
import { ReportModule } from "@/store/modules/report.store";
import { MrfiktivDocumentViewModelGen, MrfiktivReportViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { downloadUrlFromRemoteOrigin } from "@/lib/utility/downloadFileFunc";
import { simpleDate } from "@/lib/utility/date-helper";

@Component({
  components: {
    PartnerReportDetailImageTimeLineElement,
    DamageLocatorCombined
  }
})
export default class MyDamageDetail extends Vue {
  @Prop({ required: true })
  report!: MrfiktivReportViewModelGen;

  renderComponent = true;

  get reportType() {
    return this.report?.reportType;
  }

  get damageLocation() {
    this.forceRerender();
    return this.report?.damage ?? [];
  }

  get hasDamageLocation(): boolean {
    return this.damageLocation?.length > 0 || false;
  }

  get images() {
    return this.report?.images;
  }

  get hasImages() {
    if (!this.report) {
      return false;
    }

    return this.report.attachment.length > 0;
  }

  get color() {
    return ReportModule.partner.settings?.color ?? "#6fb38a";
  }

  get hasDocuments() {
    return this.report?.documents && this.report.documents.length > 0;
  }

  get documentCount() {
    return this.report?.documents?.length || 0;
  }

  get items() {
    return [
      {
        text: this.$t("report.user.MyDamageDetail.numberplate"),
        value: this.report?.numberplate || ""
      },
      {
        text: this.$t("objects.report.leasing.claimNumber"),
        value: this.report?.claimNumber
      },
      {
        text: this.$t("objects.report.status"),
        value: this.report?.status
          ? this.report?.status
          : this.$t(`enums.ProgressStatusEnum.${this.report?.progressStatus}`)
      },
      {
        text: this.$t("report.accidentDetails.date"),
        value: this.report?.accidentDetails?.date ? simpleDate(this.report?.accidentDetails?.date) : ""
      },
      {
        text: this.$t("objects.report.coverageType"),
        value: this.$t(`enums.CoverageTypeEnum.${this.report?.coverageType}`)
      },
      {
        text: this.$t("objects.report.tripType"),
        value: this.$t(`enums.TripTypeEnum.${this.report?.tripType}`)
      },
      {
        text: this.$t("objects.report.damageType"),
        value: this.$t(`enums.DamageTypeEnum.${this.report?.damageType}`)
      },
      {
        text: this.$t("report.user.MyDamageDetail.customerName"),
        value: this.report?.customerName || ""
      },

      {
        text: this.$t("report.user.MyDamageDetail.message"),
        value: this.report?.message || ""
      },
      {
        text: this.$t("objects.report.repair.startDate"),
        value: this.report?.repair?.startDate
      },
      {
        text: this.$t("objects.report.repair.endDate"),
        value: this.report?.repair?.endDate
      }
    ];
  }

  get getDamageLocatorWidth() {
    return "250px";
  }

  get getDamageLocatorHeight() {
    return "300px";
  }

  formatFileSize(bytes: number | undefined) {
    if (!bytes) return "0 MB";
    const mb = bytes / (1024 * 1024);
    if (mb < 0.1) {
      const kb = bytes / 1024;
      return kb < 1 ? "< 1 KB" : `${Math.round(kb)} KB`;
    }
    return `${mb.toFixed(1)} MB`;
  }

  async downloadDocument(document: MrfiktivDocumentViewModelGen) {
    const fileName = document.title || document.name;

    await downloadUrlFromRemoteOrigin(document.url, fileName);
  }

  openInNewTab(document: MrfiktivDocumentViewModelGen) {
    if (document.url) {
      window.open(document.url, "_blank");
    }
  }

  async downloadAllDocuments() {
    if (!this.report?.documents || this.report.documents.length === 0) {
      return;
    }

    this.report?.documents?.forEach(this.downloadDocument);
  }

  forceRerender() {
    // remove the my-component component from the DOM
    this.renderComponent = false;

    this.$nextTick(() => {
      // add my-component component in DOM
      this.renderComponent = true;
    });
  }
}
